export default __webpack_public_path__ + "static/media/discipline-engineering.14abf471.svg";